


































import { Component, Prop, Watch } from "vue-property-decorator";
import { CompleteRevisionModel } from "@/core/models";
import { QuestionnaireService } from "@/core/services";
import { InputTextareaCpt } from "@/core/components";

import AppVue from "@/AppVue.vue";

@Component({
  components: { InputTextareaCpt },
})
export default class CompleteRevisionDialogCpt extends AppVue {
  @Prop({ default: false }) showDialog: boolean;
  @Prop() questionnaireId: number;

  model = new CompleteRevisionModel();
  loading = false;

  get isOpen() {
    return this.showDialog;
  }

  private close(saved: boolean = false) {
    this.model.comments = "";
    this.$emit("close", saved);
  }

  private async save() {
    this.loading = true;
    try {
      this.model.questionnaireId = this.questionnaireId;
      await QuestionnaireService.complete(this.model);
      this.close(true);
    } catch {
      this.notify("Error", "Something went wrong on completing the revision", "error");
    } finally {
      this.loading = false;
    }
  }
}
